import { useState, useEffect } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormHelperText,
} from "@mui/material";

function CustomRadioButtons({
  name,
  label,
  value,
  items,
  handleChange,
  required = false,
  row = true,
  disabled = false,
  checks = [],
  errors = [],
  highlightError = false,
}) {
  const [error, setError] = useState(false);
  const [showError, setShowError] = useState(false);
  const [index, setIndex] = useState(0);

  const handleError = () => {
    let flag = false;
    for (let i = 0; i < checks.length; i++) {
      if (!checks[i]) {
        flag = true;
        setError(true);
        setShowError(true);
        setIndex(i);
        break;
      }
    }
    if (!flag) {
      setError(false);
      setShowError(false);
    }
  };

  useEffect(() => {
    handleError();
  }, [checks]);

  useEffect(() => {
    if (highlightError) handleError();
  }, [highlightError]);

  const displayError = showError && error;

  return (
    <FormControl fullWidth required={required} error={displayError}>
      <FormLabel>{label}</FormLabel>
      <RadioGroup
        row={row}
        value={value}
        onChange={(e) => {
          handleChange(e);
          setShowError(false);
        }}
        name={name}
      >
        {items.map((obj, i) => (
          <FormControlLabel
            key={i}
            value={obj.value}
            control={
              <Radio
                disabled={disabled}
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 19,
                  },
                }}
              />
            }
            label={obj.label}
          />
        ))}
      </RadioGroup>
      {displayError && (
        <FormHelperText>{errors[index] || "This field is required"}</FormHelperText>
      )}
    </FormControl>
  );
}

export default CustomRadioButtons;
